import MerchantFinanceTransactionApi from '@/api/merchant-finance-transaction'
import MerchantFinanceAccountStatementApi from '@/api/merchant-finance-account-statement'
import MerchantFinanceAccountStatementSummaryApi from '@/api/merchant-finance-account-statement-summary'

const state = { }

const mutations = { }

const actions = {
  /**
   * 交易管理
   */
  async listMerchantFinanceTransaction ({ commit }, params) {
    const result = await MerchantFinanceTransactionApi.list(params)
    return result
  },
  /**
   * 交易流水管理
   */
  async listMerchantFinanceAccountStatement ({ commit }, params) {
    const result = await MerchantFinanceAccountStatementApi.list(params)
    return result
  },
  async applyRefund ({ commit }, id) {
    const result = await MerchantFinanceTransactionApi.applyRefund(id)
    return result
  },
  async cancelRefund ({ commit }, id) {
    const result = await MerchantFinanceTransactionApi.cancelRefund(id)
    return result
  },
  async getServiceChargeSetting ({ commit }) {
    const result = await MerchantFinanceAccountStatementApi.getServiceChargeSetting()
    return result
  },
  async getMaxWithdrawCashAmount ({ commit }) {
    const result = await MerchantFinanceAccountStatementApi.getMaxWithdrawCashAmount()
    return result
  },
  // 提现申请
  async withdrawCashApply ({ commit }, data) {
    const result = await MerchantFinanceAccountStatementApi.withdrawCashApply(data)
    return result
  },
  /**
   * 流水汇总
   */
  async detailMerchantFinanceAccountStatementSummary ({ commit }) {
    const result = await MerchantFinanceAccountStatementSummaryApi.detail()
    return result
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/merchant-finance.js